import { useState, useCallback, useEffect } from "react"

export interface Route {
  page: "home" | "puzzle"
  slug?: string
}

function parseRoute(pathname: string): Route {
  const match = pathname.match(/^\/p\/([a-z0-9]+)$/)
  if (match) {
    return { page: "puzzle", slug: match[1] }
  }
  return { page: "home" }
}

export function useRouter() {
  const [route, setRoute] = useState<Route>(() => parseRoute(window.location.pathname))

  const navigate = useCallback((path: string) => {
    window.history.pushState(null, "", path)
    setRoute(parseRoute(path))
  }, [])

  useEffect(() => {
    const handlePopState = () => {
      setRoute(parseRoute(window.location.pathname))
    }
    window.addEventListener("popstate", handlePopState)
    return () => window.removeEventListener("popstate", handlePopState)
  }, [])

  return { route, navigate }
}
